import { createAction } from '@reduxjs/toolkit'

export interface IProvinceData {
  id: number | string
  title: string
}

export const setProvinceList = createAction<IProvinceData[]>('location/province')
